import { render, staticRenderFns } from "./SelfButton.vue?vue&type=template&id=a20692ea&"
import script from "./SelfButton.vue?vue&type=script&lang=js&"
export * from "./SelfButton.vue?vue&type=script&lang=js&"
import style0 from "./SelfButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports